import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import { connect } from "react-redux";
import {
  getInvestorDetails,
  checkKyc,
  clearingFirstTimeInvestorJourney
} from "../../../store/actions";
import { REQ_BY } from "../../../store/types";
import { NEW_TRANSACTION_URL } from ".";
import { KycNotDoneDialog } from "../customModal";

import CustomLoader from "../../forms/Loader";

class NewInvestorSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      openModal: false,
      errorMessage: "",
    };
  }

  changeInput = (event) => {
    // if (
    //   !!event.target.value.charAt(3) &&
    //   (event.target.value.charAt(3) === "p" ||
    //     event.target.value.charAt(3) === "P")
    // ) {
    this.setState({
      inputValue: event.target.value.toUpperCase(),
      errorMessage: "",
    });
    // } else {
    //   this.search({
    //     errorMessage: ""
    //   });
    // }
  };

  keyPress = (e) => {
    if (e.key === "Enter") {
      this.search();
    }
  };

  closeModal = () => {
    this.setState({
      openModal: false,
    });
  };

  continue = () => {
    this.closeModal();
    this.props.history.push({
      pathname:
        NEW_TRANSACTION_URL,
    });
  };

  search = async () => {
    const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if (!this.state.inputValue || !regpan.test(this.state.inputValue)) {
      this.setState({ errorMessage: "Please enter a valid PAN to proceed" });
    } else if (
      this.state.inputValue[3] !== "P" &&
      this.state.inputValue[3] !== "P"
    ) {
      this.setState({
        errorMessage:
          "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number",
      });
    } else {
      const params = {
        Uid: this.props.userId,
        ReqBy: REQ_BY,
        PAN: this.state.inputValue.toUpperCase(),
        customfund: "189",
      };
      this.setState({ isLoading: true });
      const response = await this.props.getInvestorDetails(params);
      await this.props.clearingFirstTimeInvestorJourney();
      if (response) {
        this.setState({ isLoading: false });
        this.props.history.push({
          pathname: NEW_TRANSACTION_URL + "/transction-types",
          pan: this.state.inputValue,
        });
      } else {
        this.setState({ isLoading: true });
        const kycResponse = await this.props.checkKyc({
          fund: "189",
          userid: this.props.userId,
          i_pan: this.state.inputValue,
        });
        this.setState({ isLoading: false });
        const {
          DtData: [info],
        } = kycResponse;
        if (info.KYCBlock === "N") {
          await this.props.clearingFirstTimeInvestorJourney();
          this.props.history.push({
            pathname: "new-investor-transaction/investor-details",
            state: {
              pan: !!this.state.inputValue ? this.state.inputValue : "",
            },
          });
        } else {
          this.setState({ openModal: true });
        }
      }
    }
  };

  render() {
    return (
      <div>
        <Paper
          className="investor-paper"
          style={{ boxShadow: "0px 1px 3px 0px lavender", marginBottom: 20 }}
        >
          <CustomLoader display={this.state.isLoading} />
          <div className="investor-input-div">
            <SearchIcon className="investor-input-searchicon" />
            <InputBase
              value={this.state.inputValue}
              placeholder="Search by PAN"
              className="investor-input-inputbase"
              onChange={this.changeInput}
              onKeyPress={this.keyPress}
              inputProps={{
                "aria-label": "Search",
                maxLength: "10",
              }}
            />
          </div>
          <div className="investor-search-button" onClick={this.search}>
            Search
          </div>
        </Paper>
        {!!this.state.errorMessage && (
          <div
            style={{
              fontSize: 15,
              fontFamily: "Rubik-Italic",
              color: "red",
            }}
          >
            {this.state.errorMessage}
          </div>
        )}
        <KycNotDoneDialog
          open={this.state.openModal}
          close={this.closeModal}
          continue={this.continue}
        />
      </div>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const { userId } = authReducer;
    return { userId };
  },
  {
    getInvestorDetails,
    checkKyc,
    clearingFirstTimeInvestorJourney
  }
)(NewInvestorSearch);
